import { Button, styled } from '@mui/material';

import { textFieldDefaultStyle } from '../../components/UI/Typography';

export const datePickerStyle = {
  ...textFieldDefaultStyle,
  width: '25%',
};

export const textTimeDefaultStyle = {
  ...textFieldDefaultStyle,
  width: '15%',
};

export const OutlinedButton = styled(Button)(({ theme }) => ({
  border: `2px solid ${theme.palette.secondary.main}`,
  borderRadius: '16px',
  color: theme.palette.secondary.main,
  fontWeight: '600',
  backgroundColor: '#FAFCFF',
  textTransform: 'lowercase',
  '&:disabled': {
    color: theme.palette.primary.main,
  },
}));
